/*
 * Generated by orval v3.2.3 🍺
 * Do not edit manually.
 * BFF Customers Api
 * OpenAPI spec version: v6
 */

export type SupportType = 'ELECTRONIC' | 'PAPER';

export const SupportType = {
  ELECTRONIC: 'ELECTRONIC' as SupportType,
  PAPER: 'PAPER' as SupportType,
};
